import { GqlError } from "../GqlError";

/**
 * Creates a batching decorator for GraphQlFetcher
 */
const batchMiddleware = (deferFn = setTimeout) => next => {
	let deferId = null;
	let lastContext;
	let operations = [];
	let resolvers = [];

	const appendOperation = (operation, context) => (resolve, reject) => {
		operations.push(operation);
		resolvers.push({ resolve, reject });
		lastContext = context;

		deferId =
			deferId ||
			deferFn(() => {
				const currentOperations = [...operations];
				const currentResolvers = [...resolvers];

				deferId = null;
				operations = [];
				resolvers = [];

				next(currentOperations, lastContext)
					.then(results =>
						results.forEach((result, index) =>
							result instanceof GqlError
								? currentResolvers[index].reject(result)
								: currentResolvers[index].resolve(result),
						),
					)
					.catch(err => currentResolvers.forEach(resolver => resolver.reject(err)));
			});
	};

	return (operation, context) => new Promise(appendOperation(operation, context));
};

export default batchMiddleware;
